export default {
  SIGNATURE_PATH: '/public/jssdk/config',
  AUTH_PATH: '/public/sns/code',
  JS_API_LIST: [
    'updateAppMessageShareData',
    'updateTimelineShareData',
    'onMenuShareTimeline',
    'onMenuShareAppMessage',
    'previewImage',
    'hideMenuItems',
    'hideAllNonBaseMenuItem'
  ]
}



// WEBPACK FOOTER //
// ./src/constants/jweixin-config.js